module.exports = "https://www.gc-pro.gnp.com.mx/62b42073eaf956991c3d343b2a9e5fd3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icon-seguridad.svg
// module id = 1839
// module chunks = 0